import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { settingsService } from '../services/settingsService';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: 'Tchamba MarketPlace',
    site_description: 'La plateforme qui connecte vendeurs et acheteurs locaux à Tchamba.',
    site_logo: '',
    maintenance_mode: false,
    registration_enabled: true,
    email_verification_required: true
  });
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  const loadSettings = useCallback(async (forceReload = false) => {
    if (initialized && !forceReload) return; // Éviter les appels multiples sauf si forcé
    
    try {
      // console.log('SettingsContext: Chargement des paramètres...', forceReload ? '(forcé)' : '(normal)');
      setLoading(true);
      const data = await settingsService.getSystemSettings();
      // console.log('SettingsContext: Données reçues:', data);
      if (data && data.settings) {
        // console.log('SettingsContext: Mise à jour des paramètres:', data.settings);
        // Mise à jour optimisée - éviter les re-renders inutiles
        setSettings(prevSettings => {
          const newSettings = { ...prevSettings, ...data.settings };
          // Ne mettre à jour que si les valeurs ont vraiment changé
          if (JSON.stringify(prevSettings) !== JSON.stringify(newSettings)) {
            return newSettings;
          }
          return prevSettings;
        });
      } else {
        // console.log('SettingsContext: Pas de données settings dans la réponse');
      }
    } catch (error) {
      console.error('SettingsContext: Erreur lors du chargement des paramètres:', error);
      // Les valeurs par défaut sont déjà définies dans useState
    } finally {
      setLoading(false);
      setInitialized(true);
    }
  }, [initialized]);

  useEffect(() => {
    // Charger les paramètres au montage du composant
    if (!initialized) {
      // console.log('SettingsContext: useEffect déclenché, chargement des paramètres...');
      const loadData = async () => {
        await loadSettings();
      };
      loadData();
    }
  }, [initialized, loadSettings]); // Charger une seule fois au montage

  const value = {
    settings,
    loading,
    loadSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
